import React from 'react'

/** deprecated the key string should be used */
export enum KeyCodes {
  escapeKey = 27,
  enterKey = 13
}

enum Keys {
  escapeKeyIE = 'Esc',
  escapeKey = 'Escape',

  enterKeyIE = 'Ent',
  enterKey = 'Enter',

  arrowDown = 'ArrowDown',
  arrowUp = 'ArrowUp',

  alt = 'Alt',
  control = 'Control',
  shift = 'Shift',
  meta = 'Meta'
}

export enum KeyType {
  EscKey,
  EnterKey,
  ModifierKey,
  ArrowUpKey,
  ArrowDownKey
}

export const isKeyType = (event: React.KeyboardEvent<unknown> | KeyboardEvent, isKey: KeyType) => {
  switch (event.key) {
    case Keys.escapeKey:
    case Keys.escapeKeyIE:
      return isKey === KeyType.EscKey
    case Keys.enterKey:
    case Keys.enterKeyIE:
      return isKey === KeyType.EnterKey
    case Keys.arrowDown:
      return isKey === KeyType.ArrowDownKey
    case Keys.arrowUp:
      return isKey === KeyType.ArrowUpKey
    case Keys.alt:
    case Keys.control:
    case Keys.shift:
    case Keys.meta:
      return isKey === KeyType.ModifierKey
  }

  /** if not returned at this point, also check the deprecated event.keyCode */
  switch (event.keyCode) {
    case KeyCodes.escapeKey:
      return isKey === KeyType.EscKey
    case KeyCodes.enterKey:
      return isKey === KeyType.EnterKey
  }

  return false
}

export const newEnterKeyDownEvent = (): KeyboardEvent => {
  const virtualEvent = new KeyboardEvent('keydown', { code: 'Enter', key: 'Enter', keyCode: 13, bubbles: true, cancelable: true })
  return virtualEvent
}

export const newArrowDownKeyDownEvent = (): KeyboardEvent => {
  const virtualEvent = new KeyboardEvent('keydown', {
    code: 'ArrowDown',
    key: 'ArrowDown',
    keyCode: 40,
    bubbles: true,
    cancelable: true
  })
  return virtualEvent
}
